function getBrandIdentifier(route) {
  return { brandIdentifier: Number(route.query.brandIdentifier) };
}

export default [
  // 팝업으로 띄우는 페이지의 불필요한 소켓 연결을 방지하기 위해 라우터를 분리함
  {
    name: 'operation_ticket',
    path: '/operation/ticket',
    meta: {
      title: '티켓 상세',
      requiresBrandKey: false
    },
    component: () => import(/* webpackChunkName: "OperationTicketDetails" */ '@/components/operation/fragments/right/operation_ticket_details'), // 상담데스크 -> 티켓 상세
    props: getBrandIdentifier
  },
  {
    name: 'external_chat_messages',
    path: '/external/chat_messages',
    meta: {
      title: '웹챗 보기 팝업',
      requiresAuth: false
    },
    component: () => import(/* webpackChunkName: "ChatMessages" */ '../../components/external/chat_messages') // 티켓 상세 -> 웹챗 보기 팝업(새창)
  },
  {
    name: 'survey',
    path: '/survey/:type',
    meta: {
      title: '설문 조사',
      requiresAuth: false
    },
    component: () => import(/* webpackChunkName: "Survey" */ '@/components/menus/survey/survey')
  },
  {
    name: 'agent_reservation_ticket',
    path: '/agent/reservation/ticket',
    meta: {
      title: '예약 상담 티켓 상세',
      requiresAuth: false
    },
    component: () => import(/* webpackChunkName: "ReservationTicketDetails" */ '@/views/agent/components/reservationTicketDetails'), // 설정 -> 콜 상담 관리 -> 예약 상담 -> 티켓 상세
    props: getBrandIdentifier
  },
  {
    name: 'commerceProcess',
    path: '/operation/commerce/process',
    component: () => import(/* webpackChunkName: "commerceProcess" */ '@/components/operation/fragments/right/commerceProcess'),
    meta: {
      requiresAuth: false
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/subRoutes/popup.js